import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import Responsive from 'react-responsive';
import './OnboardingContainerAA.css';

class WelcomePage extends Component {
    constructor(props) {
        super(props);
    }



    render() {
        return (
            <div className="welcome-container">
                <div className="welcome-main">
                    <div className="welcome-text-title">Your digital   <Responsive minWidth={767}><br/></Responsive> skin consultant</div>
                    <div className="welcome-text-info-container paragraphRegular3">
                        <div style={{marginTop:'20px',lineHeight:1}} className="h4">$10 consultation fee credited toward your purchase</div>
                        <div className="welcome-text-info-one">Let's get to know each other. Take this quiz and we will match you with a licensed esthetician to build you a personalized skincare routine. Your skin will thank you!</div>
                        
                        {/* <div className="welcome-text-info-two">The $10 consultation fee will be credited toward your purchase.</div> */}
                    </div>
                    <button onClick={()=>{  this.props.history.push('/onboarding') }} className="p-a-n-button">Let’s go!</button>
                </div>
            </div>
        )
    }
}

export default withRouter(connect()(WelcomePage))



// WEBPACK FOOTER //
// ./src/views/onboardingAA/WelcomePage.js